import { jsx } from "@builder.io/qwik/jsx-runtime";
import { component$, useSignal, useContext, useTask$ } from "@builder.io/qwik";
import { isServer } from "@builder.io/qwik/build";
import SelectContextId from "./select-context.qwik.mjs";
const HiddenSelectOption = component$(({ value, displayValue, nativeSelectRef, index, ...rest }) => {
  const optionRef = useSignal();
  const context = useContext(SelectContextId);
  useTask$(async function modularFormsValidation({ track }) {
    track(() => context.selectedIndexSetSig.value);
    if (isServer || !nativeSelectRef.value || !optionRef.value)
      return;
    const inputEvent = new Event("input", {
      bubbles: false
    });
    nativeSelectRef.value?.dispatchEvent(inputEvent);
    optionRef.value.selected = context.selectedIndexSetSig.value.has(index);
  });
  return /* @__PURE__ */ jsx("option", {
    ref: optionRef,
    value,
    ...rest,
    children: displayValue
  });
});
export {
  HiddenSelectOption
};
